module.exports = __webpack_public_path__ + "static/media/Healthcare_Hero_02.add2ac6d.jpg";